import { VApp } from 'vuetify/lib/components/VApp';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{style:(_vm.cssTheme),attrs:{"id":"xipp"}},[[_c('msg'),_c('router-view',{class:{ 'quote-css': _vm.isQuoteRoute },attrs:{"name":"container"}}),_c('keep-alive',[_c('router-view',{attrs:{"name":"containerkeepalive"}})],1)],_c(VFooter,{staticClass:"mt-1 d-flex justify-center",attrs:{"color":"footer"}},[_vm._v("\n    Powered by Xipp © "+_vm._s(new Date().getFullYear())+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }